import React from "react";

import { FIELD_TYPE, tabKeys, TT_PHIEU_VTYT } from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import { ColumnProps } from "../../../../../types/models";
import { listGender } from "../../../../../data/list";
import { trangThaiPKOptions } from "../../../../../assets/constants/select-catagory-options";
import { formatNumber, formatToCurrencyType } from "helper/common";

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER } = FIELD_TYPE;
const listSetting = [
  { value: "A", label: "Phần trăm bảo hiểm y tế, bảo hiểm xã hội NLD đóng" },
  { value: "B", label: "Phần trăm bảo hiểm y tế NLĐ đóng" },
  { value: "C", label: "Phần trăm bảo hiểm thất nghiệp NLĐ đóng" },
  { value: "D", label: "Số tiền giảm trừ NPT/1 người" },
  { value: "E", label: "Giảm trừ bản thân" },
  { value: "F", label: "Mức đóng đoàn phí công đoàn tối đa" },
  { value: "G", label: "Mức đóng BHTN tối đa" },
  { value: "H", label: "Mức đóng BHXH tối đa" },
  { value: "BHXHTDTV", label: "BHXH tối đa theo vùng" },
  { value: "Dưới", label: "Phần trăm tính lương làm thêm ngày thường (%)" },
  { value: "K", label: "Phần trăm tính lương làm thêm ngày cuối tuần (%)" },
  { value: "L", label: "Phần trăm tính lương làm thêm ngày lễ tết (%)" },
  { value: "A1", label: "Phần trăm bảo hiểm y tế, bảo hiểm xã hội NSDLĐ đóng" },
  { value: "B1", label: "Phần trăm bảo hiểm y tế NSDLĐ đóng" },
  { value: "C1", label: "Phần trăm bảo hiểm thất nghiệp NSDLĐ" },
  { value: "M", label: "Phần trăm đóng đoàn phí công đoàn" },
  { value: "SN", label: "Số tiền thưởng sinh nhật (VND)" },
  { value: "PBE", label: "Mức TU_2% (Paid by employee)" }, 
];
function formatNumberTo(number: number | string): string {
  const numString: string = number.toString();
  const parts: string[] = numString.split('.');

  // Phần nguyên
  const integerPart: string = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  // Phần thập phân (nếu có)
  const decimalPart: string = parts[1] ? `,${parts[1]}` : '';

  // Kết hợp phần nguyên và thập phân để tạo số đã được định dạng
  const formattedNumber: string = integerPart + decimalPart;

  return formattedNumber;
}
const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    fixed: "left",
    width: 30,
    align:"center",
    isResizable: true,
  },
  {
    title: "Mã cấu hình",
    key: "maCauHinh",
    show: true,
    dataIndex: "maCauHinh",
    align: "left",
    width: 80,
    isResizable: true,
  },
  {
    title: "Tên cấu hình",
    key: "tenCauHinh",
    show: true,
    dataIndex: "tenCauHinh",
    isResizable: true,
    align: "left",
    width: 180,
  },
  {
    title: "Giá trị",
    key: "giaTri",
    show: true,
    dataIndex: "giaTri",
    align: "right",
    width: 140,
    isResizable: true,
    render(value, record, index) {
      return <>{formatNumber(value)}</>;
    },
  },

  {
    title: "Mô tả",
    key: "moTa",
    show: true,
    isResizable: true,
    dataIndex: "moTa",
    width: 160,
    align: "left",
  },

  {
    title: "Tác vụ",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 70,
    key: "action",
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: INPUT,
    name: "maCauHinh",
    label: "Mã cấu hình",
    expand: false,
  },
  {
    type: INPUT,
    name: "tenCauHinh",
    expand: false,
    label: "Tên cấu hình",
  //  options: listSetting,
  },
];

export {allColumns, itemsInputField };
